import { Breadcrumbs, LoadingState, View, Workspace } from "components/Shared";
import React from "react";
import { RouteComponentProps } from "react-router";
import Form from "./Form";
import { useGetTenancy } from "v2/hooks";

import { useParams } from "react-router-dom";

interface Props extends RouteComponentProps {
	match: any;
}

const EditTenancy = ({ history }: Props) => {
	const { id } = useParams() as any;

	const { tenancy, datasource: tenancyDatasource } = useGetTenancy(id, {
		fields: JSON.stringify({
			tenancy: [
				"area",
				"building_name",
				"floor_name",
				"name",
				"building_id",
				"floor_id",
				"occupancy_status",
				"property_id",
				"kind",
				"country",
				"address",
				"exclude",
				"zone",
				"sub_zone",
				"portfolio",
				"location",
				// Yardi unit fields. This is a SPARSE FIELDSET — a field absent from
				// this list is not returned by the API at all, so the form input
				// renders blank no matter what the column holds.
				//
				// "unit_status" is deliberately absent: it is lease-level and now lives
				// on Lease, edited via components/Leases/Edit.tsx.
				"unit_code",
				"removed_flag",
				"relocation_status",
				"unit_occ_status",
				"area_id",
				// Feeds the read-only "Area (Lease Area)" input (see Tenancies/Form.jsx).
				// DERIVED server-side from the measurement in force today, not a column
				// and not writable — the edit form posts no `area` at all.
				"lease_area_sqm",
				// The dated area series, rendered read-only beside the form. A sparse
				// fieldset omits anything not named here, so leaving it out renders an
				// empty table however much history the unit has.
				"area_measurements",
			],
		}),
	});

	const putTenancy = (tenancy: any) => {
		console.log("putTenancy: ", { tenancy });

		tenancyDatasource
			.put("v2", `tenancies/${tenancy.id}`, { body: { tenancy } })
			.then(({ normalizedMainModelResponse }: any) => {
				// setLease(normalizedMainModelResponse);
				history.goBack();
			});
	};

	if (tenancyDatasource?.isLoading) return <LoadingState />;

	if (!!tenancy) {
		return (
			<React.Fragment>
				{" "}
				<Breadcrumbs items={[{ title: "Tenancy" }, { title: "", link: `/tenancies` }, { title: "edit" }]} />
				<Workspace id="lease-edit">
					<View>
						<Form tenancy={tenancy} onUpdate={putTenancy} oldBuildingId={tenancy.building_id} />
					</View>
				</Workspace>
			</React.Fragment>
		);
	}
	return null;
};

export default EditTenancy;
